module.exports = __webpack_public_path__ + "img/moving.fcdecc59.png";